import { useEffect } from "react";

const useFontSize = () => {
  useEffect(() => {
    // Load settings from localStorage
    const savedSettings = localStorage.getItem("webPlayerSettings");

    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      const fontSize = settings.fontSize || "Default";

      // Remove all font size classes
      document.documentElement.classList.remove(
        "text-size-small",
        "text-size-default",
        "text-size-large",
        "text-size-extra-large"
      );

      // Add the appropriate class
      switch (fontSize) {
        case "Small":
          document.documentElement.classList.add("text-size-small");
          break;
        case "Large":
          document.documentElement.classList.add("text-size-large");
          break;
        case "Extra Large":
          document.documentElement.classList.add("text-size-extra-large");
          break;
        default:
          document.documentElement.classList.add("text-size-default");
          break;
      }
    } else {
      // Apply default font size if no settings saved
      document.documentElement.classList.add("text-size-default");
    }
  }, []);
};

export default useFontSize;
